var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CoreButton',{on:{"click":_vm.reload}},[_c('Icon',{staticClass:"md:mr-2",attrs:{"icon":"mdi-refresh"}}),_c('span',{staticClass:"hidden md:inline-block"},[_vm._v("Обновить")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }